import { lazy, useState } from "react";
import { Outlet } from "react-router-dom";
import Loadable from "./Loadable";
const Header = Loadable(lazy(() => import("../Components/Header")));
const Footer = Loadable(lazy(() => import("../Components/Footer")));


export default function Layout() {

  const content = {
    title: "If you can imagine it you can build it",
    desc: "Speak with our team on how to bring Fusion into your tech stack.",
    btn: "Get in Touch",
    img: "/assets/img/footer/c20.webp",
  };

  const [ctaSec, setCtaSec] = useState(content);

  return (
    <>
      <Header />
      <div className="take">
        <Outlet context={{ setCtaSec }} />
      </div>
      <Footer content={ctaSec} />
    </>
  );
}
